import { useCallback, useEffect } from 'react';

import type { AdvanceFilter } from '@/_containers';
import { FilterApplyTrigger, FilterTypeSelector, getFilterKey, getFilterValue, useFiltersState } from '@/_containers';
import { snackbar } from '@/_shared';

import { type InvoiceBatchFilterSchema, useInvoiceBatchFilterFormContext } from '../../shared/filters';

export function InvoiceBatchCustomFilterWithRadios({
  handleSubmitAdvFilters,
  ...perFilter
}: AdvanceFilter<InvoiceBatchFilterSchema> & {
  handleSubmitAdvFilters: (v: AdvanceFilter<InvoiceBatchFilterSchema>) => void;
}) {
  const { mainKey, subKey, subKey2, types, selectedType, applied } = perFilter;
  const form = useInvoiceBatchFilterFormContext();

  const {
    typeState: [type, setType],
    transition: [isPending, startTransition],
    inputValueRequired,
  } = useFiltersState(null as string | null, types, selectedType);

  const isForm = false;
  const isMultiFilter = false;

  const handleSubmit = useCallback(() => {
    if (!isForm) {
      console.warn('not form field');
      return;
    }

    if (type === null || typeof type === 'undefined' || type === '') {
      snackbar.error('Please select a filter type');
      return;
    }

    const selectedType = types.find((f) => f.value === type) ?? { name: '', value: '' };
    const key = getFilterKey(mainKey, subKey, subKey2, selectedType?.absoluteKey) as keyof InvoiceBatchFilterSchema;

    const specificKey = key;
    // if (isMultiFilter) {
    //   specificKey = mainKey;
    // }

    const specifValueToCheckOnly = form.getValues(specificKey) ?? '';

    if (
      (!specifValueToCheckOnly ||
        (isMultiFilter && Array.isArray(specifValueToCheckOnly) && specifValueToCheckOnly.length === 0)) &&
      inputValueRequired
    ) {
      snackbar.error('Please select a value');
      return;
    }

    let fromV: string | number = '';
    const formValueAll = form.getValues(mainKey as keyof InvoiceBatchFilterSchema);
    const formValue = inputValueRequired ? (Array.isArray(formValueAll) ? formValueAll[0] : formValueAll) : '';

    if (subKey && typeof formValue !== 'string') {
      if (isMultiFilter && Array.isArray(formValueAll)) {
        fromV = formValueAll.map((item) => item[subKey as keyof typeof item]).join(', ');
      } else if (subKey2) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fromV = (formValue?.[subKey as keyof typeof formValue]?.[subKey2 as keyof typeof formValue] ?? '').toString();
      } else {
        fromV = (formValue?.[subKey as keyof typeof formValue] ?? '').toString();
      }
    } else {
      fromV = (formValue ?? '').toString();
    }

    const { filter, filterValue } = getFilterValue(type, key, [fromV]);

    startTransition(() => {
      handleSubmitAdvFilters({
        ...perFilter,
        applied: true,
        filterValue,
        valueToApply: filter,
        selectedType,
      });
    });
  }, [
    isForm,
    type,
    types,
    mainKey,
    subKey,
    subKey2,
    form,
    inputValueRequired,
    startTransition,
    isMultiFilter,
    handleSubmitAdvFilters,
    perFilter,
  ]);

  useEffect(() => {
    if (!applied) {
      form.setValue(mainKey as keyof InvoiceBatchFilterSchema, null as never);
      setType(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applied]);

  if (!isForm) {
    console.warn('not form field');
    return null;
  }

  return (
    <section className={'flex flex-col'}>
      {inputValueRequired && <></>}

      <FilterTypeSelector
        className={inputValueRequired ? 'mt-0' : undefined}
        types={types}
        type={type}
        setType={setType}
      />

      <FilterApplyTrigger handleSubmit={handleSubmit} isPending={isPending} />
    </section>
  );
}
